const cards = [
  {
    tag: "独家",
    tagColor: "bg-primary-500 text-background-50",
    img: "https://readdy.ai/api/search-image?query=Backstage%20of%20a%20film%20set%20at%20night%2C%20director%20chair%20and%20clapperboard%20in%20foreground%2C%20warm%20practical%20lamps%20and%20harsh%20spotlight%20bleeding%20through%20dark%20curtains%2C%20candid%20stolen%20moment%20editorial%20photo%2C%20amber%20and%20vermillion%20tones%2C%20grainy%20film%20look%2C%20cinematic%20composition&width=720&height=460&seq=5gua-excl-b&orientation=landscape",
    alt: "深夜片场内的导筒与场记板",
    title: "杀青宴当晚，有人没等散场就先走了",
    dek: "知情人还原了那位「提前离场」演员当晚的通话内容。",
    author: "娱记 · 阿禾",
  },
  {
    tag: "内幕",
    tagColor: "bg-foreground-950 text-background-50",
    img: "https://readdy.ai/api/search-image?query=Inside%20a%20dark%20recording%20studio%20with%20a%20single%20warm%20microphone%20light%2C%20scattered%20contract%20papers%20and%20ink%20stamp%20on%20table%2C%20moody%20vermillion%20and%20amber%20lighting%2C%20secretive%20whistleblower%20mood%2C%20editorial%20documentary%20photography%2C%20grainy%20analog%20texture%2C%20cinematic%20composition&width=720&height=460&seq=5gua-excl-c&orientation=landscape",
    alt: "录音棚里亮着灯的麦克风与散落的合约",
    title: "一纸「甜饼」合约，压垮了多少新人",
    dek: "三年不涨、独家捆绑……我们从解约群里翻出 12 份真实模板。",
    author: "深挖 · 老K",
  },
];

export default function Exclusives() {
  return (
    <section id="exclusives" className="mt-16 md:mt-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="flex items-center gap-2 text-[11px] tracking-[0.25em] text-primary-700 font-label">
              <i className="ri-flashlight-fill text-accent-500 w-4 h-4 flex items-center justify-center" />
              独家 · 内幕放料
            </p>
            <h2 className="mt-2 font-serif text-3xl font-black text-foreground-950 md:text-4xl">
              独家，只此一家
            </h2>
          </div>
          <p className="text-sm text-foreground-500 font-label">
            标注 <span className="text-primary-700 font-medium">独家</span> 的内容，别家可不一定有
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
          {/* big feature cover */}
          <a
            href="#feed"
            className="group lg:col-span-7 relative block overflow-hidden rounded-lg cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Dramatic%20editorial%20magazine%20cover%20of%20a%20person%20seen%20through%20blurred%20glass%20door%20of%20a%20private%20club%20entrance%20at%20midnight%2C%20neon%20sign%20reflection%20in%20warm%20amber%20and%20vermillion%20red%2C%20security%20guard%20and%20tall%20bodyguard%20silhouette%2C%20mysterious%20moody%20atmosphere%2C%20grainy%20analog%20film%20photography%2C%20high%20contrast%20elegant%20editorial%20composition&width=980&height=1120&seq=5gua-excl-hero&orientation=portrait"
              alt="私人会所深夜玻璃门后的身影"
              title="5吃瓜网独家 · 密会对象终于被拍到正面"
              className="h-[440px] w-full object-cover transition-transform duration-500 group-hover:scale-105 md:h-[560px]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/25 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-foreground-950">
                <i className="ri-flashlight-fill text-sm w-4 h-4 flex items-center justify-center" />
                独家 · 首爆
              </span>
              <h3 className="mt-3 font-serif text-2xl font-black leading-snug text-background-50 text-balance md:text-[32px] md:leading-[1.2]">
                密会对象正面照，被我们拿下了
              </h3>
              <p className="mt-2 max-w-lg text-sm leading-relaxed text-background-50/85">
                不是同行艺人，也不是经纪人。当晚真正坐到对面的人，身份让整个团队当场沉默。
              </p>
              <div className="mt-4 flex items-center gap-3 text-xs text-background-50/70 font-label">
                <span>首发记者 · 老瓜</span>
                <span>·</span>
                <span>7 分钟前</span>
                <span className="inline-flex items-center gap-1 text-accent-300 group-hover:gap-2 transition-all">
                  进入独家现场
                  <i className="ri-arrow-right-line text-sm w-4 h-4 flex items-center justify-center" />
                </span>
              </div>
            </div>
          </a>

          {/* two stacked covers */}
          <div className="lg:col-span-5 flex flex-col gap-6">
            {cards.map((c) => (
              <a
                key={c.title}
                href="#feed"
                className="group flex flex-col gap-0 overflow-hidden rounded-lg border border-background-300/60 bg-background-50 transition-colors hover:border-primary-200 cursor-pointer"
              >
                <div className="overflow-hidden">
                  <img
                    src={c.img}
                    alt={c.alt}
                    title={`5吃瓜网${c.tag} · ${c.title}`}
                    className="h-44 w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-5">
                  <span
                    className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-medium ${c.tagColor}`}
                  >
                    {c.tag}
                  </span>
                  <h3 className="mt-2.5 font-serif text-lg font-bold leading-snug text-foreground-900 group-hover:text-primary-700 md:text-xl">
                    {c.title}
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{c.dek}</p>
                  <p className="mt-3 text-xs text-foreground-400 font-label">{c.author}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}